var map = {
	"./affix/style/index.tsx": "./components/affix/style/index.tsx",
	"./alert/style/index.tsx": "./components/alert/style/index.tsx",
	"./anchor/style/index.tsx": "./components/anchor/style/index.tsx",
	"./auto-complete/style/index.tsx": "./components/auto-complete/style/index.tsx",
	"./avatar/style/index.tsx": "./components/avatar/style/index.tsx",
	"./back-top/style/index.tsx": "./components/back-top/style/index.tsx",
	"./badge/style/index.tsx": "./components/badge/style/index.tsx",
	"./breadcrumb/style/index.tsx": "./components/breadcrumb/style/index.tsx",
	"./button/style/index.tsx": "./components/button/style/index.tsx",
	"./calendar/style/index.tsx": "./components/calendar/style/index.tsx",
	"./card/style/index.tsx": "./components/card/style/index.tsx",
	"./carousel/style/index.tsx": "./components/carousel/style/index.tsx",
	"./cascader/style/index.tsx": "./components/cascader/style/index.tsx",
	"./checkbox/style/index.tsx": "./components/checkbox/style/index.tsx",
	"./col/style/index.tsx": "./components/col/style/index.tsx",
	"./collapse/style/index.tsx": "./components/collapse/style/index.tsx",
	"./comment/style/index.tsx": "./components/comment/style/index.tsx",
	"./config-provider/style/index.tsx": "./components/config-provider/style/index.tsx",
	"./date-picker/style/index.tsx": "./components/date-picker/style/index.tsx",
	"./divider/style/index.tsx": "./components/divider/style/index.tsx",
	"./drawer/style/index.tsx": "./components/drawer/style/index.tsx",
	"./dropdown/style/index.tsx": "./components/dropdown/style/index.tsx",
	"./empty/style/index.tsx": "./components/empty/style/index.tsx",
	"./form/style/index.tsx": "./components/form/style/index.tsx",
	"./grid/style/index.tsx": "./components/grid/style/index.tsx",
	"./icon/style/index.tsx": "./components/icon/style/index.tsx",
	"./input-number/style/index.tsx": "./components/input-number/style/index.tsx",
	"./input/style/index.tsx": "./components/input/style/index.tsx",
	"./layout/style/index.tsx": "./components/layout/style/index.tsx",
	"./list/style/index.tsx": "./components/list/style/index.tsx",
	"./locale-provider/style/index.tsx": "./components/locale-provider/style/index.tsx",
	"./mention/style/index.tsx": "./components/mention/style/index.tsx",
	"./menu/style/index.tsx": "./components/menu/style/index.tsx",
	"./message/style/index.tsx": "./components/message/style/index.tsx",
	"./modal/style/index.tsx": "./components/modal/style/index.tsx",
	"./notification/style/index.tsx": "./components/notification/style/index.tsx",
	"./pagination/style/index.tsx": "./components/pagination/style/index.tsx",
	"./popconfirm/style/index.tsx": "./components/popconfirm/style/index.tsx",
	"./popover/style/index.tsx": "./components/popover/style/index.tsx",
	"./progress/style/index.tsx": "./components/progress/style/index.tsx",
	"./radio/style/index.tsx": "./components/radio/style/index.tsx",
	"./rate/style/index.tsx": "./components/rate/style/index.tsx",
	"./row/style/index.tsx": "./components/row/style/index.tsx",
	"./select/style/index.tsx": "./components/select/style/index.tsx",
	"./skeleton/style/index.tsx": "./components/skeleton/style/index.tsx",
	"./slider/style/index.tsx": "./components/slider/style/index.tsx",
	"./spin/style/index.tsx": "./components/spin/style/index.tsx",
	"./statistic/style/index.tsx": "./components/statistic/style/index.tsx",
	"./steps/style/index.tsx": "./components/steps/style/index.tsx",
	"./switch/style/index.tsx": "./components/switch/style/index.tsx",
	"./table/style/index.tsx": "./components/table/style/index.tsx",
	"./tabs/style/index.tsx": "./components/tabs/style/index.tsx",
	"./tag/style/index.tsx": "./components/tag/style/index.tsx",
	"./time-picker/style/index.tsx": "./components/time-picker/style/index.tsx",
	"./timeline/style/index.tsx": "./components/timeline/style/index.tsx",
	"./tooltip/style/index.tsx": "./components/tooltip/style/index.tsx",
	"./transfer/style/index.tsx": "./components/transfer/style/index.tsx",
	"./tree-select/style/index.tsx": "./components/tree-select/style/index.tsx",
	"./tree/style/index.tsx": "./components/tree/style/index.tsx",
	"./upload/style/index.tsx": "./components/upload/style/index.tsx",
	"./version/style/index.tsx": "./components/version/style/index.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.tsx?$";